// Admin-Panel: Registrierung für die Andockstelle (features/extras/index.tsx, bindet der Integrator ein).
import type { ExtraMenuItem, ExtraRoute } from '../index';
import { AdminPanel } from './AdminPanel';

export const adminRoutes: ExtraRoute[] = [{ path: '/admin/*', element: AdminPanel }];

/** Nur für Plattform-Admins anzeigen (`adminOnly`, Feld ergänzt der Integrator an ExtraMenuItem). */
export const adminMenuItems: (ExtraMenuItem & { adminOnly: true })[] = [
  { id: 'admin', label: 'Admin-Panel', slot: 'userMenu', to: '/admin', adminOnly: true },
];

/** IDs der Menüeinträge, die nur Admins sehen dürfen. */
export const ADMIN_ONLY_MENU_IDS: readonly string[] = ['admin'];

export { AdminPanel } from './AdminPanel';
export { AdminGuard } from './AdminGuard';
export { applyBridgeStatus, applyLimits, ADMIN_BRIDGE_KEY, ADMIN_LIMITS_KEY, ADMIN_STATS_KEY, ADMIN_QUERY_ROOT } from './realtime';
export { bridgeInviteUrl } from './bridge-utils';
